import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Countries } from "@models/const/countries";

// Импорты из Vue 3 Composition API
import { ref, computed, onMounted, watch } from "vue";
// Определение пропсов компонента

export default /*#__PURE__*/_defineComponent({
  __name: 'select-country',
  props: {
	value: { type: String, default: "" },
	valueCode: { type: String, default: "" },
},
  emits: ["change", "update:message"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

const countries = Countries;
const country = ref("");
const phoneCode = ref("");
onMounted(() => {
	if (props.valueCode) {
		const res = countries.find((el) => el.value == props.valueCode);
		country.value = res?.value;
	}
});
country.value;
watch(
	() => country.value,
	(value) => {
		const x = Countries.find((el) => el.value == value);
		phoneCode.value = x.code;
	}
);
function changeCountry(value) {
	emits("change", value);
	emits("update:message", value);
}

return (_ctx: any,_cache: any) => {
  const _component_ui_select_autocomplete = _resolveComponent("ui-select-autocomplete")!

  return (_openBlock(), _createBlock(_component_ui_select_autocomplete, {
    keyField: "value",
    valueField: "text",
    selectText: "value",
    items: _unref(countries),
    class: "indentification-input mr-4",
    style: {"flex":"0.5"},
    noUndefined: true,
    modelValue: country.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((country).value = $event)),
      changeCountry
    ]
  }, null, 8, ["items", "modelValue"]))
}
}

})